import Vue from 'vue'
import _ from 'lodash'
import App from './App.vue'
import './plugins/ajax.js'

Vue.config.productionTip = false

import { Popup } from 'vant';
Vue.use(Popup);
import { Picker } from 'vant';
Vue.use(Picker);
import { Toast } from 'vant';
Vue.use(Toast);

let pc_check = ()=>document.body.clientWidth>987,
  global = {
    pc: pc_check(),
  };
window.onresize = (e)=>{
  global.pc = pc_check();
};
Vue.mixin({
  data() {
    return {
      global,
    }
  },
});
Vue.filter('img-pc', src=>{
  return ('//fontstar.oss-cn-beijing.aliyuncs.com/award2025/'+(global.pc?src.replace(/([^.]*)/,'$1-pc'):src))
});
Vue.filter('img', src=>{
  return ('//fontstar.oss-cn-beijing.aliyuncs.com/award2025/'+src)
});

new Vue({
  render: h => h(App),
}).$mount('#app')
